











import { IPark } from '@/models/IPark.model';
import { IStore } from '@/models/IStore.model';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
@Component({
  components: {}
})
export default class InputPark extends Vue {

  private mounted(){
    
  }

  public setPark(park: IPark){
    this.$store.dispatch('setPark', park)
  }

  public get parks(): IPark[]{
    return this.$store.state.parks;
  }

  public get park(): IPark{
    return this.$store.state.park;
  }

  public get parksOrderd(): IPark[]{
    return this.parks.sort(function(a, b) {
      return a.name.localeCompare(b.name);
    })
  }

}
